<template>
  <vSelect
    class="geo-modal__select"
    :class="{'geo-modal__select--select': type === 'select', 'shops-filter__select-city': shopsFilter}"
    :placeholder="$t('search_city')"
    label="label"
    :value="selectValue"
    :options="cityOptions"
    @search="handleSearch"
    @input="sendCity"
    :clearable="false"
  >
    <span slot="no-options">{{ emptyError }}</span>
  </vSelect>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import { debounce, formattedDeliveryInfo } from '@/mixins'
import axios from 'axios'

export default {
  name: 'GeoSelectCity',
  mixins: [
    debounce,
    formattedDeliveryInfo
  ],
  components: {
    vSelect
  },
  props: {
    geoModal: {
      type: Boolean,
      default: false
    },
    userTypeModal: {
      type: Boolean,
      default: false
    },
    checkAvailability: {
      type: Boolean,
      default: false
    },
    shopsFilter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    withoutUpdateLocation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchValue: '',
      citiesInSelect: []
    }
  },
  computed: {
    ...mapState({
      productId: state => state.productInfo.productInfo.productId,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      popularCities: state => state.geoLocation.popularCities,
      selectedCityOnShops: state => state.shops.selectedCity,
      citiesListOnShops: state => state.shops.cities,
      currLocale: state => state.translation.language
    }),
    ...mapGetters(['urlLanguagePrefix']),
    emptyError () {
      return this.searchValue.length < 1 ? this.$t('enter_3_characters_geo') : this.$t('not_found_geo')
    },
    cityOptions () {
      return this.citiesInSelect.map(el => {
        return { ...el, label: el.name[this.currLocale] }
      })
    },
    selectValue () {
      if (this.withoutUpdateLocation) {
        return this.selectedCityOnShops.name[this.currLocale]
      }

      return this.selectedUserLocation.name[this.currLocale]
    }
  },
  methods: {
    ...mapActions(['SEND_USER_CITY', 'FETCH_PRODUCT_AVAILABILITY_IN_SHOPS', 'SET_SELECTED_CITY_ACTION']),
    handleSearch (value) {
      this.searchValue = value
      if (!value) {
        this.citiesInSelect = []
        return
      }
      this.debounce(() => {
        axios.get(this.urlLanguagePrefix + '/shop/checkout/get-cities/', { params: { city: value } })
          .then(response => {
            if (this.searchValue) this.citiesInSelect = response.data.cities
          })
      }, 300)
    },
    sendCity (city) {
      if (this.withoutUpdateLocation) {
        if (city) this.SET_SELECTED_CITY_ACTION(city)
      } else {
        if (city) {
          this.SEND_USER_CITY(city.id || city.city_id)

          if (this.geoModal) {
            this.$modal.hide('geo-modal')
          }

          if (this.checkAvailability) {
            this.FETCH_PRODUCT_AVAILABILITY_IN_SHOPS({ productId: this.productId, cityId: city.id })
          }
        }
      }
    }
  },
  mounted () {
    if (this.type === 'select' && this.popularCities && !this.withoutUpdateLocation) {
      this.citiesInSelect = this.popularCities
    }

    if (this.withoutUpdateLocation && this.citiesListOnShops) {
      this.citiesInSelect = this.citiesListOnShops
    }
  },
  watch: {
    popularCities (value) {
      if (value && this.type === 'select') {
        this.citiesInSelect = this.popularCities
      }
    },
    citiesListOnShops (value) {
      if (value && this.withoutUpdateLocation) {
        this.citiesInSelect = this.citiesListOnShops
      }
    }
  }
}
</script>

<style lang="sass">

@import '~@/styles/blocks/checkout-form/libraries-elements'

.geo-modal__select
  position: relative
  width: 100%
  color: $text-color

  +mmin($small)
    width: 540px

  .vs__search
    padding: 5px 14px
    font-size: 14px

    &::placeholder
      color: $placeholder-color

  .vs__dropdown-menu
    box-shadow: 0 2px 10px rgba(51, 51, 51, 0.25)
    border: 0
    max-height: 200px

    li
      font-size: 14px!important

  .vs__dropdown-option
    padding: 9px 16px
    font-size: 14px

    &--highlight
      background: $nd-disabled-background-color
      color: $text-color

  .vs__selected
    display: block
    width: 90%
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    margin: 7px 9px 0

  .vs__dropdown-toggle
    height: 40px

.geo-modal__select:not(.geo-modal__select--select)
  .vs__actions
    display: none

// custom clases
.shops-filter__select-city
  width: 100%
  background: #fff

</style>
